import { render, staticRenderFns } from "./tele-water.vue?vue&type=template&id=41bdced5&scoped=true"
import script from "./tele-water.vue?vue&type=script&lang=ts"
export * from "./tele-water.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bdced5",
  null
  
)

export default component.exports